module.exports = __webpack_public_path__ + "static/media/Glide-192x192.5e8c7ea2.png";